import type { FC } from 'react'

import './index.styles.scss'

const colors = [
  '#F1E5C3', // pastel yellow
  '#E9B9B7', // pastel pink
  '#A7B3D3', // pastel blue
  '#95D7D0', // pastel turquoise
  '#C8AABF', // pastel lavender
  '#E9C7AF', // pastel peach
  '#A6C5A6', // pastel sage
  '#EFD1D9', // pastel rose
  '#B5B5A4', // pastel grey
  '#D5C5DE', // pastel lilac
  '#C4A7A1', // pastel salmon
  '#7DE5B5', // pastel mint
  '#E5D087', // pastel apricot
  '#A3C6E8', // pastel sky blue
]

function convertStringToNumber(name: string): number {
  const reverseName = name.split(' ').reverse().join('')
  let hash = 0
  for (let i = 0; i < reverseName.length; i++) {
    hash = reverseName.charCodeAt(i) + ((hash << 5) - hash)
  }

  let number = hash % colors.length

  return Math.abs(number)
}

const initialsFromWords = (words: string[]) =>
  words
    .map(word => word[0])
    .join('')
    .toUpperCase()

const getInitials = (name: string): string => {
  const words = getWordsFromString(name)
  if (words.length <= 3) {
    return initialsFromWords(words)
  } else {
    const firstName = words.shift() || ''
    const lastName = words.pop() || ''
    const middleName = words.pop() || ''
    return initialsFromWords([firstName, middleName, lastName])
  }
}

const getWordsFromString = (str: string) => str.trim().split(' ')

export const NameAvatar: FC<{ name: string | null }> = ({ name }) => {
  if (!name) {
    return null
  }
  const initials = getInitials(name)
  const color = colors[convertStringToNumber(name)]

  return (
    <div className="name-avatar" style={{ backgroundColor: color }}>
      <span>{initials}</span>
    </div>
  )
}
